// @ts-strict-ignore
import { lighten } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  avatar: {
    flex: '1 0 auto',
    width: 100,
    height: 100,
    borderRadius: '50px',
    marginRight: 0,
  },
  description: {
    flex: '1 0 content',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  title: {
    flex: '1 0 auto',
    color: lighten(theme.palette.text.dark, 0.25),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  button: {
    flex: '1 0 auto',
  },
  actualUpload: {
    display: 'none',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  fileName: {
    marginTop: theme.spacing(1),
  },
  error: {
    color: theme.palette.error.main,
  },
  buttonIcon: {
    marginRight: `${theme.spacing(2)} !important`,
  },
  buttonLabel: {
    display: 'inline-block',
    transform: 'translateY(1px)',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}))
